export default function EmailGreyIcon({
    style,
}) {
    return <svg style={style} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.70073C1 1.31373 1.31373 1 1.70073 1H16.2993C16.6863 1 17 1.31373 17 1.70073V12.3333C17 12.5101 16.9298 12.6797 16.8047 12.8047C16.6797 12.9298 16.5101 13 16.3333 13H1.66667C1.48986 13 1.32029 12.9298 1.19526 12.8047C1.07024 12.6797 1 12.5101 1 12.3333V1.70073Z" fill="white" stroke="#676767" strokeWidth="0.7" />
        <path d="M16.2782 1.05469L9.49592 7.83697C9.22227 8.11063 8.77859 8.11063 8.50494 7.83697L1.72266 1.05469" stroke="#676767" strokeWidth="0.7" />
    </svg>
}